export default __webpack_public_path__ + "static/media/slider1.87f711e5.png";